// react
import React from 'react';

// mui
import { Container, Stack } from '@mui/material';

export interface CenterPageTemplateProps {
  children?: React.ReactNode;
}

/**
 * CenterPageTemplate centers its children within a maxWidth container.
 */
export const CenterPageTemplate = ({ children }: CenterPageTemplateProps) => {
  return (
    <Stack
      sx={{
        height: '100%',
        paddingY: 2,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Container maxWidth='xs'>{children}</Container>
    </Stack>
  );
};

CenterPageTemplate.displayName = 'CenterPageTemplate';
export default CenterPageTemplate;
